module.exports = __webpack_public_path__ + "media/share_images/keyboard-50022d52.svg";